// URL API bisa diganti lewat file .env: REACT_APP_API_URL=https://.../apiweb/
// (harus diakhiri "/")
export const API_URL =
  process.env.REACT_APP_API_URL || "https://webauth.bintangwistar.my.id/apiweb/";

// Beberapa endpoint (mis. getDetailImageProduk.php) masih mengembalikan URL
// absolut ke host lama (http://api.bintangwistar.com/...) yang sudah tidak
// aktif. Fungsi ini membuang host lama tsb dan mengarahkannya ke API_URL,
// misalnya "http://api.bintangwistar.com/imgOrigin/a.png"
//   -> "https://webauth.bintangwistar.my.id/apiweb/imgOrigin/a.png".
export const toApiUrl = (url) => {
  if (!url) return url;
  const match = url.match(/^https?:\/\/[^/]+\/(?:apiweb\/)?(.*)$/i);
  const path = match ? match[1] : url.replace(/^\/+/, "");
  return API_URL + path;
};
